import { render, staticRenderFns } from "./PurchasesDetail.vue?vue&type=template&id=7c4ca706"
import script from "./PurchasesDetail.vue?vue&type=script&lang=js"
export * from "./PurchasesDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchasesDetail.vue?vue&type=style&index=0&id=7c4ca706&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports